import { NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseModule } from '../shared/base.module';
import { DialogsModule } from '../shared/dialogs/dialogs.module';

import { InventoryActionDetailsComponent } from './actions/details/inventory-action-details.component';
import { InventoryActionsComponent } from './actions/inventory-actions.component';
import { InventoryComponent } from './inventory.component';
import { InventoryProductDetailsComponent } from './products/details/inventory-product-details.component';
import { InventoryProductsComponent } from './products/inventory-products.component';
import { CommonFormsModule } from '../shared/common-forms/common-forms.module';
import { InventoryActionRowDetailsComponent } from './actions/row-details/inventory-action-row-details.component';
import { InventoryPricingsComponent } from './pricings/inventory-pricings.component';
import { InventoryActionForPricingDetailsComponent } from './actions/details/inventory-action-for-pricing-details/inventory-action-for-pricing-details.component';
import { InventoryActionForBuyOrderDetailsComponent } from './actions/details/inventory-action-for-buy-order-details/inventory-action-for-buy-order-details.component';
import { InventoryActionForMovementDetailsComponent } from './actions/details/inventory-action-for-movement-details/inventory-action-for-movement-details.component';
import { ChipComponent } from '../shared/ui/chip/chip.component';
import { DocumentWorksComponent } from '../shared/works/document-works.component';
import { DocumentSelectComponent } from '../shared/document-select/document-select.component';
import { GoToCreateDirective } from '../shared/directives/go-to-create.directive';
import { PricingEditFormComponent } from './actions/form/edit/pricing-edit-form/pricing-edit-form.component';
import { GoToEditDirective } from '../shared/directives/go-to-edit.directive';


@NgModule({
  declarations: [
    InventoryActionDetailsComponent, 
    InventoryActionsComponent,
    InventoryComponent,
    InventoryProductDetailsComponent,
    InventoryProductsComponent,
    InventoryActionRowDetailsComponent,
    InventoryPricingsComponent,
    InventoryActionForPricingDetailsComponent,
    InventoryActionForBuyOrderDetailsComponent,
    InventoryActionForMovementDetailsComponent,
  ],
  imports: [
    BaseModule,
    ChipComponent,
    CommonFormsModule,
    DialogsModule,
    DocumentSelectComponent,
    GoToCreateDirective,
    GoToEditDirective,
    PricingEditFormComponent,
    DocumentWorksComponent,
  ],
  exports: [
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class InventoryModule {}
